// Reach router supports relative paths, but the breadcrumb generator currently only speaks
// absolute paths.

export const OIDC_SIGNIN = '/oidc_signin';

export const COMPANY_PATH = '/company/:companyId';

export const ARCADE_PATH_UPDATE = '/:arcadeId/update';
export const ARCADE_PATH_CREATE = '/create';
export const ARCADES_PATH = '/arcades';

export const ROM_PATH_UPDATE = '/:romId/update';
export const ROM_PATH_CREATE = '/create';
export const ROMS_PATH = '/roms';

export const TOKENS_PATH = '/tokens';
// export const TOKENS_PATH_CREATE = '/create';
export const TOKENS_PATH_LIST = '/list';

export function swapPathCompanyId(pathname: string, companyId: string) {
    let pathWithinCompany = pathname.replace(/^\/company\/[^/]+/, '');

    // Default redirect to the Arcade
    if (pathWithinCompany.match(/^\/*$/) || pathWithinCompany.match(/update/)) {
        pathWithinCompany = ARCADES_PATH;
    }

    return `/company/${companyId}${pathWithinCompany}`;
}
